import {ValueObject} from '@s-ui/domain'
import {toQueryString} from '@s-ui/js/lib/string'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'

const isNotNumber = num => num === null || isNaN(num)

export class GetVehicleAiSeoContentRequest extends ValueObject {
  #make
  #makeId
  #model
  #modelId

  static validate({makeId, modelId}) {
    if (isNotNumber(makeId)) {
      throw InvalidParamsSharedError.create(
        `[GetVehicleAiSeoContentRequest.validate] param makeId is required and should be a number`
      )
    }

    if (modelId !== null && modelId !== undefined && isNotNumber(modelId)) {
      throw InvalidParamsSharedError.create(
        `[GetVehicleAiSeoContentRequest.validate] param modelId should be a number when provided`
      )
    }
  }

  constructor({makeId, modelId, make, model}) {
    super()
    this.#make = make
    this.#makeId = makeId
    this.#model = model
    this.#modelId = modelId
  }

  static create({make, makeId, model, modelId}) {
    GetVehicleAiSeoContentRequest.validate({makeId, modelId})
    return new GetVehicleAiSeoContentRequest({
      make,
      makeId,
      model,
      modelId
    })
  }

  get makeId() {
    return this.#makeId
  }

  get modelId() {
    return this.#modelId
  }

  get make() {
    return this.#make
  }

  get model() {
    return this.#model
  }

  get value() {
    return {
      make: this.#make,
      makeId: this.#makeId,
      model: this.#model,
      modelId: this.#modelId
    }
  }

  toQueryString() {
    const queryParams = {
      makeId: this.#makeId,
      ...(this.#make && {make: this.#make})
    }

    if (this.#modelId !== null && this.#modelId !== undefined) {
      queryParams.modelId = this.#modelId
      if (this.#model) {
        queryParams.model = this.#model
      }
    }

    return toQueryString(queryParams)
  }
}
